import Icon from '../components/Icon.vue'

Icon.register({
  'file-pdf': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zM180.2 303.3c9.6 17.4 21.8 31.2 34.5 40.8-23.9 4.7-44.6 14.9-62.9 21.9 11.1-19.4 20.7-42.5 28.4-62.7zM86.1 428.1c5.8-15.7 28.2-33.9 34.9-40.2-21.7 34.8-34.9 41-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136c0 13.2 10.8 24 24 24zM240 331.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-0.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-0.1 0-0.1 0.1-0.2 0.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105c4.5 4.5 7 10.6 7 16.9v6.1h-128v-128h6c6.4 0 12.5 2.5 17 7zM302.9 360.3c0 0-5.7 6.8-42.8-9 40.3-2.9 46.9 6.3 42.8 9z'
      }
    ]
  }
})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/file-pdf.js